import { onCLS, onINP, onLCP } from 'web-vitals/attribution';

// Reports Core Web Vitals with attribution to GA4 so field regressions
// (which Lighthouse's single cold load can't reproduce) can be traced to a
// specific element / interaction. Events are custom (`web_vitals`) and only
// reach GA when analytics consent is granted — gtag drops them otherwise.
function send({ name, value, rating, delta, id, attribution }) {
  if (typeof window === 'undefined' || !window.gtag) return;

  const params = {
    value: delta,
    metric_id: id,
    metric_value: value,
    metric_rating: rating,
    non_interaction: true,
  };

  switch (name) {
    case 'CLS':
      params.debug_target = attribution.largestShiftTarget;
      params.debug_time = Math.round(attribution.largestShiftTime || 0);
      params.debug_load_state = attribution.loadState;
      break;
    case 'INP':
      params.debug_target = attribution.interactionTarget;
      params.debug_event = attribution.interactionType;
      params.debug_time = Math.round(attribution.interactionTime || 0);
      params.debug_load_state = attribution.loadState;
      params.debug_input_delay = Math.round(attribution.inputDelay || 0);
      params.debug_processing = Math.round(attribution.processingDuration || 0);
      params.debug_presentation = Math.round(attribution.presentationDelay || 0);
      break;
    case 'LCP':
      params.debug_target = attribution.element;
      params.debug_url = attribution.url;
      break;
    default:
      break;
  }

  window.gtag('event', name, params);
}

let started = false;

export function initWebVitals() {
  if (started || typeof window === 'undefined') return;
  started = true;
  onCLS(send);
  onINP(send);
  onLCP(send);
}
